import React from 'react';
import { Button } from 'antd';
import { Icon, Tooltip } from '@components';
import styled, { css } from 'styled-components';

const ButtonStyled = styled(Button)`
  ${(props) =>
    props.type === 'success' &&
    css`
      background-color: #00c851 !important;
      border-color: #00c851 !important;
      color: ${(props) => (props.ghost ? '#00C851' : '#fff')} !important;
    `}
  ${(props) =>
    props.type === 'warning' &&
    css`
      background-color: #ffbb33 !important;
      border-color: #ffbb33 !important;
      color: ${(props) => (props.ghost ? '#ffbb33' : '#fff')} !important;
    `}
`;

const ButtonComponent = React.forwardRef(({ children, visible, ...otherProps }, ref) => {
  if (!visible) return null;

  return (
    <ButtonStyled {...otherProps} ref={ref}>
      {children}
    </ButtonStyled>
  );
});

ButtonComponent.defaultProps = {
  visible: true,
};

ButtonComponent.Group = Button.Group;

const handleButtonTypes = (type) => {
  switch (type) {
    case 'add':
      return css`
        color: white;
        background-color: #28a745;
      `;

    case 'edit':
      return css`
        color: white;
        background-color: #40a9ff;
      `;

    case 'delete':
      return css`
        color: white;
        background-color: #dc3545;
      `;

    default:
      return css`
        background-color: #ddd;
      `;
  }
};

const Presets = styled(ButtonComponent)`
  transition: 0.2s;
  border-radius: 5px;

  :hover {
    ${(props) => handleButtonTypes(props.type)}
  }
`;

const PresetButton = (CustomIcon, { tooltipTitle, type, ...otherProps }) => (
  <Tooltip title={tooltipTitle}>
    <Presets type={type} {...otherProps}>
      <CustomIcon />
    </Presets>
  </Tooltip>
);

const AddButton = ({ tooltipTitle, ...otherProps }) => PresetButton(Icon.PlusOutlined, { tooltipTitle, type: 'add', ...otherProps });

const BackButton = ({ history, ...otherProps }) =>
  PresetButton(Icon.LeftOutlined, {
    tooltipTitle: 'Voltar',
    onClick: () => {
      history.goBack();
    },
    style: { marginBottom: 10 + 'px', borderRadius: 5 + 'px' },
    ...otherProps,
  });

const DefaultButton = ({ customIcon, tooltipTitle, ...otherProps }) => PresetButton(customIcon, { tooltipTitle, ...otherProps });

const SubmitButton = styled(ButtonComponent)`
  width: 120px;
`;

export { ButtonComponent, AddButton, DefaultButton, BackButton, SubmitButton };
